/* eslint-disable import/no-unresolved */
import { Avatar, Box, Button, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import profile from "../../../../../assets/images/user3.png";
import { ReactComponent as Exalamation } from "../../../../../assets/invoice/bi_exclamation.svg";
import { ReactComponent as Question } from "../../../../../assets/invoice/ep_question-filled.svg";
import { ReactComponent as Tick } from "../../../../../assets/invoice/ic_round-check.svg";
import { ReactComponent as RTick } from "../../../../../assets/invoice/Vector.svg";
import SubHeader from "../../../../../components/SubHeader";
import color from "../../../../../constants/color";
import InvoiceList from "./InvoiceList";
import RecurringTemplateList from "./RecurringTemplateList";
import styles from "./style";

const InvoicePage = ({
  handleDownload,
  data,
  handleSearch,
  total,
  page,
  setPage,
  handleDelete,
  handleDeleteRecurringTemplate,
  recurringTemplateData,
  recurringTemplatePage,
  setRecurringTemplatePage,
  totalRecurringTemplates,
}) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("Invoice");
  const navigate = useNavigate();

  const handleCreateNavigate = (item) => {
    navigate("/dashboard/createInvoice", { state: { item } });
  };

  const handleText = (text) => {
    handleSearch(text);
  };
  const handleSort = (sort) => {
    handleSearch("", sort);
  };

  const handleTabChange = (tab) => setActiveTab(tab);

  const tabSx = (tab) => ({
    fontWeight: 600,
    px: 2,
    pb: 1,
    cursor: "pointer",
    color: activeTab === tab ? color.primary : theme.palette.text.primary,
    borderBottom: `3px solid ${
      activeTab === tab ? color.primary : "transparent"
    }`,
    transition: "all 0.2s ease",
  });

  return (
    <>
      <Box px="15px" pt="20px">
        <Typography sx={styles.leaveHeading}>Invoice</Typography>
      </Box>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px">
            <Box sx={styles.cardBox}>
              <Box sx={styles.iconSection}>
                <Tick style={styles.dollarIcon} />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>982</Typography>
                <Typography sx={styles.monthlyText}>Invoice Sent</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px">
            <Box sx={styles.cardBox}>
              <Box sx={styles.QiconSection}>
                <Question />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>45</Typography>
                <Typography sx={styles.monthlyText}>Pending Invoice</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={5} sx={styles.StatBox}>
          <Typography sx={styles.totalText}>Total balance</Typography>
          <Typography sx={styles.totalCount}>$4811,21</Typography>
        </Grid>
      </Grid>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px">
            <Box sx={styles.cardBox}>
              <Box sx={styles.TiconSection}>
                <RTick style={styles.dollarIcon} />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>73</Typography>
                <Typography sx={styles.monthlyText}>Paid Voice</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px">
            <Box sx={styles.cardBox}>
              <Box sx={styles.EiconSection}>
                <Exalamation />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>168</Typography>
                <Typography sx={styles.monthlyText}>Unpaid Invoice</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={5} sx={styles.invoiceBox}>
          <Typography sx={styles.invoiceText}>Last Invoice</Typography>
          <Box sx={styles.profileSection}>
            <Box sx={styles.profileGrid}>
              <Avatar src={profile} sx={styles.avatar}></Avatar>
              <Typography sx={styles.userName}>Barry Leo</Typography>
            </Box>
            <Box sx={styles.cardSubtitle}>2 days ago</Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={styles.gridText}>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Box sx={tabSx("Invoice")} onClick={() => handleTabChange("Invoice")}>
            Invoice
          </Box>
          <Box
            sx={tabSx("Recurring Invoice")}
            onClick={() => handleTabChange("Recurring Invoice")}
          >
            Recurring Invoice
          </Box>
        </Box>
        <Button
          variant="contained"
          color="success"
          sx={styles.checkoutBtn}
          onClick={() => handleCreateNavigate()}
        >
          + Create Invoice
        </Button>
      </Box>

      <Box
        sx={{
          backgroundColor: theme.palette.white.main,
          m: 2,
          borderRadius: "20px",
        }}
      >
        <SubHeader
          search={true}
          sortBy={true}
          onchange={handleText}
          handleSort={handleSort}
        />

        {activeTab === "Invoice" ? (
          <InvoiceList
            handleDownload={handleDownload}
            data={data}
            total={total}
            page={page}
            setPage={setPage}
            handleDelete={handleDelete}
          />
        ) : (
          <RecurringTemplateList
            data={recurringTemplateData}
            total={totalRecurringTemplates}
            page={recurringTemplatePage}
            setPage={setRecurringTemplatePage}
            handleDeleteRecurringTemplate={handleDeleteRecurringTemplate}
          />
        )}
      </Box>
    </>
  );
};

export default InvoicePage;
